import { CONSTS } from '../../config/objectConst'

export async function integrateHotJar(userId: string) {
	if (import.meta.env.PUBLIC_HOTJAR !== 'true') {
		return
	}

	const { default: Hotjar } = await import('@hotjar/browser')

	Hotjar.init(CONSTS.HJ_ID, CONSTS.HJ_SV)
	Hotjar.identify(userId, { userProperty: 'value' })
}
